import { Card } from 'antd';
import styles from './DiagramNode.module.css';

import * as icons from '@ant-design/icons';

const DiagramNode = (props) => {
  const Icon = icons[props.icon];
  return (
    <>
      <Card className={styles.node}>
        <Card.Meta
          title={<span class={styles['node-title']}>{props.title}</span>}
          description={<span className={styles['node-description']}>{props.description}</span>}></Card.Meta>
      </Card>
      <p className={styles.dot}>&#x25CF;</p>
    </>
  );
};

export default DiagramNode;
